// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2ViLQ","smallLinkTypography":"_25l8P","titleTypography":"_2DsJB","cardTitleTypography":"_3n91G","truncate":"_2lAND","base":"YLA4_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Grid/Row/Row.scss
// module id = 1853
// module chunks = 0